import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

export default function save({ attributes, clientId }) {
  const blockProps = useBlockProps.save();
  const { flexClass } = attributes;

  const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
    className: `bf_layout ${flexClass}`,
  });

  return (
    <swiper-slide>
      <div {...blockProps}>
        <div {...innerBlocksProps}>{children}</div>
      </div>
    </swiper-slide>
  );
}
